import { compose } from '@fluentui/react-bindings';
import { commonPropTypes } from '../../utils';
import { Box } from '../Box/Box';
export var listItemHeaderMediaClassName = 'ui-list__itemheadermedia';

/**
 * Provides a header media for the ListItem.
 */
export var ListItemHeaderMedia = /*#__PURE__*/function () {
  var ListItemHeaderMedia = compose(Box, {
    className: listItemHeaderMediaClassName,
    displayName: 'ListItemHeaderMedia',
    overrideStyles: true,
    shorthandConfig: {
      mappedProp: 'content'
    }
  });
  ListItemHeaderMedia.propTypes = commonPropTypes.createCommon();
  return ListItemHeaderMedia;
}();
//# sourceMappingURL=ListItemHeaderMedia.js.map
